<template>
  <v-container fluid class="language-selection-banner">
    <v-row >
      <v-spacer />
      <v-col cols="2">
        <v-img
          :src="busImage"            
          :alt="t('app.busImageAlt')"
          max-height="50"
          contain
        />
      </v-col>
      <v-col cols="2">
        <v-img
          :src="TfWLogo"
          :alt="t('app.logoAlt')"
          max-height="50"
          contain
        />
      </v-col>
      <v-spacer />
    </v-row>  
  </v-container>
	<div
		class="language-selection-overlay"
		:style="overlayBackgroundStyle"
		role="dialog"
		aria-modal="true"
	>
		<div class="language-selection-container">
			<div class="button-group">
				<v-btn class="language-btn welsh-btn" @click="selectWelsh">
					Cymraeg
				</v-btn>
				<v-btn class="language-btn english-btn" @click="selectEnglish">
					English
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import { i18n } from "@/i18n/i18n";
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data : () => ({
    busImage: require("@/assets/bus.svg"),
    TfWLogo: require("@/assets/TfWLogo.svg"),
  }),
	computed: {
		overlayBackgroundStyle() {
			return {
				backgroundImage: `url('${process.env.BASE_URL}img/Bus%20image.svg')`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			};
		},
	},
	methods: {
		...mapActions(["updateLanguage"]),
		selectEnglish() {
			this.updateLanguage("en");
			i18n.global.locale.value = "en";
			this.$emit("language-selected");
		},
		selectWelsh() {
			this.updateLanguage("cy");
			i18n.global.locale.value = "cy";
			this.$emit("language-selected");
		},
	},
};
</script>

<style scoped>
.language-selection-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 10vh;
  min-height: 55px;;
  background-color: #ffffff;
  color: #2e2e2e;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3001;
  border-radius: 0 0 8px 8px;
  box-shadow: #2e2e2e 0px 4px 12px;
}
.language-selection-overlay {
	position: fixed;
	inset: 0;
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 3000;
}

.language-selection-container {
	width: 100%;
	height: 100%;
	
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 24px;
}

.language-selection-container h1 {
	margin: 0 0 12px;
}

.language-selection-container p {
	margin: 0 0 24px;
}

.button-group {
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
	justify-content: center;
}

.language-btn {
	min-width: 120px;
	font-weight: 700;
  border-radius: 40px;

}

.english-btn {
	background-color: #ffffff!important;
	color: #2e2e2e !important;
}

.welsh-btn {
	background-color: #ffffff !important;
	color: #2e2e2e !important;
}

@media (max-width: 600px) {
	.button-group {
		flex-direction: column;
		width: 100%;
		max-width: 320px;
	}

	.language-btn {
		width: 100%;
	}
}
</style>